module.exports = __webpack_public_path__ + "static/media/sweat-with-stagger.e9fcc15f.svg";